"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const RareDropTable_1 = __importStar(require("../../../subtables/RareDropTable"));
const ScorpiaUniqueTable = new LootTable_1.default().add('Odium shard 3').add('Malediction shard 3');
const ScorpiaTable = new LootTable_1.default()
    .tertiary(18, 'Ensouled scorpion head')
    .tertiary(100, 'Clue scroll (hard)')
    .tertiary(2016, "Scorpia's offspring")
    .add(ScorpiaUniqueTable, 1, 1)
    /* Weapons and armour */
    .add('Rune pickaxe', 1, 5)
    .add('Rune 2h sword', 1, 5)
    .add('Rune spear', 1, 5)
    .add('Rune chainbody', 1, 4)
    .add('Rune scimitar', 1, 4)
    .add('Rune sword', 1, 4)
    .add('Rune warhammer', 1, 4)
    .add('Dragon scimitar', 1, 1)
    /* Materials */
    .add([
    ['Uncut emerald', 6],
    ['Uncut sapphire', 4]
], 1, 5)
    .add('Grimy kwuarm', 4, 8)
    .add('Bucket of sand', 25, 6)
    .add('Cactus spine', 10, 6)
    /* Consumables */
    .add('Admiral pie', 3, 8)
    .add('Prayer potion(4)', 1, 8)
    .add('Shark', 1, 8)
    .add('Anchovy pizza', 8, 4)
    .add('Superantipoison(4)', 1, 2)
    /* Other */
    .add('Coins', [499, 3998], 18)
    .add('Phoenix necklace', 1, 7)
    .add('Dust rune', 30, 4)
    .add('Weapon poison(++)', 1, 4)
    /* Subtables */
    .add(RareDropTable_1.default, 1, 4)
    .add(RareDropTable_1.GemTable, 1, 4);
exports.default = new SimpleMonster_1.default({
    id: 6615,
    name: 'Scorpia',
    table: ScorpiaTable,
    aliases: ['scorpia']
});
//# sourceMappingURL=Scorpia.js.map